module.exports = __webpack_public_path__ + "img/Ambar-Brosur-On-Small.69437051.jpg";